import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.yAxis.name.text'),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.yAxis.name.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.yAxis.name.text', $event);
      }
    }
  })], 1), _c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.yAxis.nameGap', 30),
      "type": "number",
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.yAxis.nameGap.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        _vm.setByKey('chartOptions.yAxis.nameGap', parseInt($event || 30));
      }
    }
  })], 1), _vm.getByKey('chartOptions.type') === 'line' ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.lineChart.smooth.label')
    },
    model: {
      value: _vm.lineChartSmooth,
      callback: function ($$v) {
        _vm.lineChartSmooth = $$v;
      },
      expression: "lineChartSmooth"
    }
  })], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.grid.left', 10),
      "type": "number",
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.grid.left.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        _vm.setByKey('chartOptions.grid.left', parseInt($event || 10));
      }
    }
  })], 1), _c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.grid.right'),
      "type": "number",
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.grid.right.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        _vm.setByKey('chartOptions.grid.right', parseInt($event || 0));
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "type": "number",
      "value": _vm.getByKey('chartOptions.xAxisRotation'),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.xAxisRotation.label'),
      "persistent-hint": "",
      "hint": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.xAxisRotation.hint'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.xAxisRotation', $event, 'number');
      }
    }
  })], 1), _c(VCol, [_c(VCombobox, {
    attrs: {
      "items": _vm.axisMinMaxItems,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.yAxisMin.label'),
      "value": _vm.getByKey('chartOptions.yAxisMin') || null,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setYAxisMinMax('min', $event);
      }
    }
  })], 1), _c(VCol, [_c(VCombobox, {
    attrs: {
      "items": _vm.axisMinMaxItems,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.yAxisMax.label'),
      "value": _vm.getByKey('chartOptions.yAxisMax') || null,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "input": function ($event) {
        return _vm.setYAxisMinMax('max', $event);
      }
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };